import { Checkbox } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

interface HeaderChecboxProps {
  id: number;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  notFolioSelected: number[];
  setNotFolioSelected: React.Dispatch<React.SetStateAction<number[]>>;
  isChecked: boolean;
  disabled: boolean;
  modal?: {
    title: string;
    description: string;
  };
  setOpenModal?: Dispatch<SetStateAction<{
    open: boolean;
    title: string;
    description: string;
    id: string | number;
    confirm: () => void;
    children: JSX.Element | undefined;
    back?: () => void;
  }>>
  closeModal?: () => void;
  openModal?: boolean;
}

export const HeaderRowCheckBox: React.FC<HeaderChecboxProps> = ({
  id,
  selectedIds,
  setSelectedIds,
  notFolioSelected,
  setNotFolioSelected,
  isChecked,
  disabled,
  modal,
  setOpenModal,
  closeModal,
  openModal
}) => {
  const isHeaderSelected = isChecked;

  // Helper function to remove only first occurrence of an id
  const removeFirstOccurrence = (arr: number[], valueToRemove: number) => {
    const index = arr.indexOf(valueToRemove);
    if (index === -1) return arr;
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isHeaderSelected) {
      if (event.target.checked) {
        setNotFolioSelected(prev => removeFirstOccurrence(prev, id));
      } else {
        setNotFolioSelected(prev => [...prev, id]);
      }
    } else {
      if (event.target.checked) {
        setSelectedIds(prev => [...prev, id]);
      } else {
        setSelectedIds(prev => removeFirstOccurrence(prev, id));
      }
    }
  };

  const handleCheckboxChangeModal = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked; // ✅ Guardamos el valor real
    const target = { checked } as HTMLInputElement;

    if (openModal && setOpenModal) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        title: modal?.title ?? '',
        description: modal?.description ?? '',
        confirm: () => {
          const syntheticEvent = { target } as React.ChangeEvent<HTMLInputElement>;
          handleCheckboxChange(syntheticEvent);
          closeModal?.();
        },
        children: undefined,
        back: closeModal
      }))

    }
  };

  return (
    <Checkbox
      checked={disabled ? false : isChecked ? !notFolioSelected.includes(id) : selectedIds.includes(id)}
      onChange={!(openModal && setOpenModal) ? handleCheckboxChange : handleCheckboxChangeModal}
      disabled={disabled}
      color="primary"
    />
  );
};